import { Observable, interval } from 'rxjs';
import { debounce, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';

export default function GeozonesViewTableMapDirective() {
  function GeozoneMapController(
    $scope,
    mapService,
    equipmentRepository,
    $rootScope,
    gettextCatalog,
  ) {
    'ngInject';

    const self = this;

    const defineMarkerFeature = function (feature, latlng) {
      const result = mapService.defineMarkerFeature(feature, latlng, $scope);

      return result;
    };

    const getPinsWithinBounds = () => {
      // Make an api call to the equipment api within the current bounds!
      const lastBounds = self.map.getBounds();
      const bounds = {
        nw: {
          lat: lastBounds._northEast.lat,
          lng: lastBounds._southWest.lng,
        },
        se: {
          lat: lastBounds._southWest.lat,
          lng: lastBounds._northEast.lng,
        },
      };

      return fromPromise(
        equipmentRepository.getEquipmentSearch('*', { limit: 2500 }, null, bounds),
      );
    };

    const showPinsWithinBounds = (response) => {
      // clear marker layer
      markersLayer.clearLayers();
      markersLayer.addLayer(
        L.geoJson(mapService.getEquipmentGeoJson(response.data.hits), {
          pointToLayer: defineMarkerFeature,
        }),
      );

      // zoom to the results of the search
      if (self.map !== undefined) {
        self.map.invalidateSize(true);
      }
    };

    let refreshPins = null;
    // Observable for refresh pin events, set a debounce timer to reduce number of calls to server
    new Observable((subscriber) => {
      refreshPins = () => subscriber.next();
    })
      .pipe(
        debounce(() => interval(500)),
        switchMap(getPinsWithinBounds),
      )
      .subscribe(showPinsWithinBounds);

    self.map = mapService.createMapDiv('geozones-map');
    // hold the features drawn on the map
    self.map.setView([40, -74.5], 3); // Zoom out of new york

    self.map.scrollWheelZoom.disable();

    var markersLayer = L.markerClusterGroup({
      maxClusterRadius: 60,
      iconCreateFunction: mapService.defineClusterIcon, // this is where the magic happens for graph icons.
    });

    self.map.addLayer(markersLayer);

    const overLays = mapService.getControlLayer();

    const assetTooltip = gettextCatalog.getString('Assets');
    overLays.addOverlay(markersLayer, assetTooltip);

    const featureGroup = L.featureGroup().addTo(self.map);

    self.map.on('moveend', function (e) {
      refreshPins();
    });
    // $('.leaflet-draw-toolbar leaflet-bar leaflet-draw-toolbar-top').remove('.leaflet-draw-draw-circlemarker');
    let options = {};
    let drawControl = {};

    if ($rootScope.currentUser.features) {
      for (let i = 0; i < $rootScope.currentUser.features.length; i++) {
        if ($rootScope.currentUser.features[i].path === 'geozones.manage') {
          // drawLocal's must be before L.control.draw or they won't work
          const shapeTools = {
            actions: {
              title: gettextCatalog.getString('Cancel drawing'),
              text: gettextCatalog.getString('Cancel'),
            },
            finish: {
              title: gettextCatalog.getString('Finish drawing'),
              text: gettextCatalog.getString('Finish'),
            },
            undo: {
              title: gettextCatalog.getString('Delete last point drawn'),
              text: gettextCatalog.getString('Delete last point'),
            },
            buttons: {
              polygon: gettextCatalog.getString('Draw a polygon'),
              rectangle: gettextCatalog.getString('Draw a rectangle'),
            },
          };
          L.drawLocal.draw.toolbar = shapeTools;

          const polygonHandles = {
            tooltip: {
              start: gettextCatalog.getString('Click to start drawing shape.'),
              cont: gettextCatalog.getString('Click to continue drawing shape.'),
              end: gettextCatalog.getString('Click first point to close this shape.'),
            },
          };
          L.drawLocal.draw.handlers.polygon = polygonHandles;
          const rectangleHandles = {
            tooltip: {
              start: gettextCatalog.getString('Click and drag to draw rectangle.'),
            },
          };
          L.drawLocal.draw.handlers.rectangle = rectangleHandles;

          const editTools = {
            actions: {
              save: {
                title: gettextCatalog.getString('Save changes.'),
                text: gettextCatalog.getString('Save'),
              },
              cancel: {
                title: gettextCatalog.getString('Cancel editing, discards all changes.'),
                text: gettextCatalog.getString('Cancel'),
              },
            },
            buttons: {
              edit: gettextCatalog.getString('Edit layers.'),
              editDisabled: gettextCatalog.getString('No layers to edit.'),
              remove: gettextCatalog.getString('Delete layers.'),
              removeDisabled: gettextCatalog.getString('No layers to delete.'),
            },
          };
          L.drawLocal.edit.toolbar = editTools;

          const editHandlers = {
            edit: {
              tooltip: {
                text: gettextCatalog.getString('Drag handles, or marker to edit feature.'),
                subtext: gettextCatalog.getString('Click cancel to undo changes.'),
              },
            },
            remove: {
              tooltip: {
                text: gettextCatalog.getString('Click on a feature to remove'),
              },
            },
          };
          L.drawLocal.edit.handlers = editHandlers;

          options = {
            edit: {
              featureGroup,
              edit: true,
              remove: false,
            },
            draw: {
              polygon: {
                allowIntersection: false,
                showArea: true,
                metric: false,
                drawError: {
                  color: '#e1e100', // Color the shape will turn when intersects
                  message: gettextCatalog.getString('Intersecting shapes not allowed!'), // Message that will show when intersect
                },
                shapeOptions: {
                  color: '#1990bf',
                },
                icon: new L.DivIcon({
                  iconSize: new L.Point(15, 15),
                  className: 'leaflet-div-icon leaflet-editing-icon',
                }),
              },
              polyline: false,
              rectangle: {
                metric: false,
                shapeOptions: {
                  color: '#1990bf',
                },
                icon: new L.DivIcon({
                  iconSize: new L.Point(15, 15),
                  className: 'leaflet-div-icon leaflet-editing-icon',
                }),
              },
              circle: false,
              marker: false,
            },
          };

          // Add controls for drawing polygons
          drawControl = new L.Control.Draw(options).addTo(self.map);

          L.Edit.PolyVerticesEdit = L.Edit.PolyVerticesEdit.extend({
            options: {
              icon: new L.DivIcon({
                iconSize: new L.Point(15, 15),
                className: 'leaflet-div-icon leaflet-editing-icon',
              }),
            },
          });

          break;
        }
      }
    } // if

    // show editing and created polygons
    self.map.on('draw:created', showPolygonArea);
    self.map.on('draw:edited', showPolygonAreaEdited);
    // listen to the draw deleted event
    self.map.on('draw:deleted', function (e) {
      $scope.geometry = '';
    });

    // drawing start/stop events
    self.map.on('draw:drawstart', drawingStarted);
    self.map.on('draw:drawstop', drawingStopped);

    /**
    	  -- Drawing Started --
    	  A map event that the user has started drawing on the map
    */
    function drawingStarted(e) {
      // drawing started, so disable panning and zooming
      // Otherwise, the map moves around while trying to draw
      self.map.touchZoom.disable();
      self.map.doubleClickZoom.disable();
      self.map.dragging.disable();
    }

    /**
       -- Drawing Started --
       A map event that the user has stopped drawing on the map
    */
    function drawingStopped(e) {
      // drawing stopped, so re-enable panning and zooming
      self.map.touchZoom.enable();
      self.map.doubleClickZoom.enable();
      self.map.dragging.enable();
    }

    function showPolygonAreaEdited(e) {
      // Call some binded function to let the parent controller known its been edited
      e.layers.eachLayer(function (layer) {
        if (layer == 'circle') {
          // must have been a circle

          showCircleArea({
            layer,
          });
        } else {
          showPolygonArea({
            layer,
          });
        }
      });
    }

    function showCircleArea(e) {
      // clear layer before adding a new one
      featureGroup.clearLayers();

      // add feature to the layer
      featureGroup.addLayer(e.layer);
    }

    // editing complete, so show polygon
    // in specified color
    function showPolygonArea(e) {
      if (e.layer == 'circle') {
      } else {
        // clear layer before adding a new one
        featureGroup.clearLayers();

        // add feature to the layer
        featureGroup.addLayer(e.layer);

        // store feature as geoJSON
        const feat = e.layer.toGeoJSON();

        // store WKT in data model
        const geometry = wellknown.stringify(feat);

        $scope.geometry = geometry;
        $scope.$apply();
        $scope.onEdit();
      }
    }

    $scope.$watch('geometry', function (newVal) {
      if ($scope.geometry) {
        updateGeozone();
      }
    });

    function updateGeozone() {
      featureGroup.clearLayers();
      const geoJsonGeometry = wellknown.parse($scope.geometry);

      if (geoJsonGeometry) {
        const latLngs = []; // L.latLng(lat, lng) objects

        angular.forEach(geoJsonGeometry.coordinates[0], function (val) {
          latLngs.push(L.latLng(val[1], val[0]));
        });

        const polygon = L.polygon(latLngs, {
          color: '#1990bf',
        });

        polygon.addTo(featureGroup);
        self.map.fitBounds(featureGroup.getBounds());
      }
    }

    refreshPins();

    $('.leaflet-draw-draw-circlemarker').remove();
  }

  return {
    restrict: 'E',
    scope: {
      geometry: '=',
      onEdit: '&',
    },
    template: require('./map.html'),
    controller: GeozoneMapController,
  };
}
